// @ts-ignore
import { IModelConstructor } from '../interfaces/IModelConstructor';
import { withSelectable } from '../traits/withSelectable';
import { ListLikeVM } from './ListLikeVM';
import { computed, makeObservable } from 'mobx';
import { makeMetadata, property } from '../helpers/decorators';

export class SelectVM extends withSelectable(ListLikeVM) {
  constructor(...args: any[]) {
    super(...args);
    makeObservable(this);
    makeMetadata(this);
  }

  @property
  @computed
  get options(): object[] {
    return this.data;
  }

  set options(o: object[]) {
    this.setData(o);
  }
}
